import useHttp from 'helpers/HttpMethods';
import {
  CustomReport,
  CustomReportExecutionResultPaginated,
  CustomReportInput,
  CustomReportPaginated
} from 'types/CustomReportTypes';

const api = useHttp();

class CustomReportService {
  static async list(
    filters: string
  ): Promise<Response | CustomReportPaginated> {
    return await api.get(`/custom-reports?${filters}`);
  }

  static async findByUuid(uuid: string): Promise<Response | CustomReport> {
    return await api.get(`/custom-reports/${uuid}`);
  }

  static async create(
    body: CustomReportInput
  ): Promise<Response | CustomReport> {
    return await api.post(body, '/custom-reports');
  }

  static async update(
    uuid: string,
    body: CustomReportInput
  ): Promise<Response | CustomReport> {
    return await api.put(body, `/custom-reports/${uuid}`);
  }

  static async delete(uuid: string): Promise<Response> {
    return await api.del(`/custom-reports/${uuid}`);
  }

  static async execute(
    uuid: string,
    page: number = 0,
    size: number = 25
  ): Promise<Response | CustomReportExecutionResultPaginated> {
    return await api.post(
      {},
      `/custom-reports/${uuid}/execute?page=${page}&size=${size}`
    );
  }

  static async export(
    uuid: string,
    format: string = 'xlsx'
  ): Promise<Response> {
    return await api.postExportFile(
      `/custom-reports/${uuid}/export?format=${format}`
    );
  }
}

export default CustomReportService;
